import {getReportUrl} from 'common/report/util';
import {SharableEntityType} from 'common/report/util/saved-entities/types';

const DEFAULT_ENTITY_TYPE_PATH = `home`;
const ENTITY_TYPE_TO_PATH: Partial<Record<SharableEntityType, string>> = {
  [SharableEntityType.FeatureFlag]: `feature-flags`,
  [SharableEntityType.Experiment]: `experiments`,
};

export function getHomeUrl(
  entityType: SharableEntityType | undefined,
  {projectId, workspaceId}: {projectId: string | number; workspaceId?: string | number},
): string {
  if (!entityType) return DEFAULT_ENTITY_TYPE_PATH;
  return getReportUrl(ENTITY_TYPE_TO_PATH[entityType] ?? DEFAULT_ENTITY_TYPE_PATH, {projectId, workspaceId});
}
